import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetRolesValue, RoleLookup, Roles } from '../models';

export const rolesActions = createActionGroup({
    source: 'Roles',
    events: {
        'Get Roles': props<{ value: GetRolesValue }>(),
        'Get Roles Success': props<{ payload: Roles }>(),
        'Get Roles Error': props<{ code: number }>(),

        'Get Roles Lookup': emptyProps(),
        'Get Roles Lookup Success': props<{ payload: RoleLookup[] }>(),
        'Get Roles Lookup Error': props<{ code: number }>(),

        Clear: emptyProps(),
    },
});
